export default __webpack_public_path__ + "static/media/labTable.ac085bb2.JPG";